"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const AbstractDropdownWidget_1 = tslib_1.__importDefault(require("../AbstractDropdownWidget"));
const fmko_ts_common_1 = require("fmko-ts-common");
class GroupedDropdownWidget extends AbstractDropdownWidget_1.default {
    constructor(args) {
        super({ ...args });
        this.element.classList.add("grouped-dropdown");
    }
    setOptions(groupedOptions, fireEvents = false) {
        this.options = [];
        this.optionElements = [];
        this.optionLiToIndexMap.clear();
        this.optionToLiMap.clear();
        this.currentLiHighlighted = undefined;
        if (groupedOptions == null) {
            groupedOptions = new Map();
        }
        // Clear suggestions
        while (this.dropdownList.firstChild) {
            this.dropdownList.removeChild(this.dropdownList.firstChild);
        }
        const noOptionText = this.model.getTextForNoOptionSelected();
        if (noOptionText) {
            const noOptionLi = this.createEmptyOptionLiElement(noOptionText);
            this.dropdownList.appendChild(noOptionLi);
        }
        let index = -1;
        groupedOptions.forEach((groupItems, keyType) => {
            const group = document.createElement("ul");
            group.setAttribute("role", fmko_ts_common_1.ARIARole.GROUP);
            // Don't create a visual group presentation if only a single group exists
            if (groupedOptions.size !== 1) {
                index++;
                const presentationId = fmko_ts_common_1.GlobalCounter.next();
                const groupPresentation = document.createElement("li");
                groupPresentation.id = presentationId;
                groupPresentation.setAttribute("role", fmko_ts_common_1.ARIARole.PRESENTATION);
                groupPresentation.textContent = this.model.formatGroup(keyType);
                this.optionLiToIndexMap.set(groupPresentation, index);
                group.setAttribute(fmko_ts_common_1.ARIA.LABELLED_BY, presentationId);
                group.appendChild(groupPresentation);
            }
            groupItems.forEach((option) => {
                index++;
                const optionLiElement = this.createOptionLIElement({ option: option, isGroupElement: true });
                this.optionToLiMap.set(option, optionLiElement);
                this.optionLiToIndexMap.set(optionLiElement, index);
                this.optionElements.push(optionLiElement);
                this.options.push(option);
                group.appendChild(optionLiElement);
            });
            this.dropdownList.appendChild(group);
        });
        this.setPlaceholder(this.options.length === 0 ? this.noOptionsPlaceholder : this.regularPlaceholder);
        if (this.options.length === 1 && this.shouldSelectIfSingleOption) {
            this.setValue(this.options[0], fireEvents);
        }
        else {
            this.setValue(null, fireEvents);
        }
    }
    setUnknownValue(newValue, fireEvents) {
        if (!this.options.includes(newValue)) {
            const group = document.createElement("ul");
            group.setAttribute("role", fmko_ts_common_1.ARIARole.GROUP);
            const presentationId = fmko_ts_common_1.GlobalCounter.next();
            const groupPresentation = document.createElement("li");
            groupPresentation.id = presentationId;
            groupPresentation.setAttribute("role", fmko_ts_common_1.ARIARole.PRESENTATION);
            groupPresentation.textContent = "Ukendt værdi";
            this.optionLiToIndexMap.set(groupPresentation, this.options.length);
            group.setAttribute(fmko_ts_common_1.ARIA.LABELLED_BY, presentationId);
            group.appendChild(groupPresentation);
            const optionLiElement = this.createOptionLIElement({ option: newValue, isGroupElement: true, isUnknownOption: true });
            this.optionToLiMap.set(newValue, optionLiElement);
            this.optionLiToIndexMap.set(optionLiElement, this.options.length + 1);
            this.optionElements.push(optionLiElement);
            this.options.push(newValue);
            group.appendChild(optionLiElement);
            this.dropdownList.appendChild(group);
        }
        this.setValue(newValue);
    }
    decorateAbstractDropdownElement(args) {
        this.decorateGroupedDropdownElement(args);
    }
}
exports.default = GroupedDropdownWidget;
//# sourceMappingURL=GroupedDropdownWidget.js.map